import React, { Component } from 'react';

class About extends Component {
   state = { isOpen: false };

   handleShowDialog = () => {
     this.setState({ isOpen: !this.state.isOpen });
   };
  render() {

   var style={
      color: "#11ABB0"
   }

    if(this.props.data){
      var fullname = this.props.data.fullname;
      var birthday = this.props.data.birthday;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.objective;
      var street = this.props.data.street;
      var city = this.props.data.city;
      var country = this.props.data.country;
      var phone= this.props.data.mobile;
      var email = this.props.data.email;
      var ph = this.props.data.phone;
      var env = this.props.data.env;
      var map = this.props.data.map;
      var use = this.props.data.use;
      var cntry = this.props.data.cntry;
      var birth = this.props.data.birth;
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Youssef William Prof Pic" />
         </div>
         <div className="nine columns main-col">
            {this.props.isGerman ? <h2>Persönlich Angaben</h2> : <h2>About Me</h2>}

            <p>{bio}</p>
            <div className="row">
               <div className="columns contact-details">
                  {this.props.isGerman ? <h2>Kontaktdaten</h2> : <h2 >Contact Details</h2>}
                  <p className="address" >
                  <span><i className={use} style={style} >&nbsp;&nbsp;</i>{fullname} </span><br />
                  <span><i className={birth} style={style}>&nbsp;&nbsp;</i> {birthday}</span><br/>
						   <span><i className={map} style={style}  >&nbsp;&nbsp;</i> {street}<br />
                     &emsp; {city} 
                   </span><br />
                   <span ><i className={cntry} style={style}  >&nbsp;&nbsp;</i> {country}</span><br />
						   <span ><i className={ph} style={style}  >&nbsp;&nbsp;</i> {phone}</span><br />
                     <span> <i className={env} style={style} >&nbsp;&nbsp;</i><a href={"mailto:" + email}>{email}</a></span>
					   </p>
               </div>
               <div className="columns download">
                  <p>
                     <a target="_blank" rel="noopener noreferrer" className="button" href={this.props.isGerman ? "https://drive.google.com/uc?export=download&id=1u7EkpM6UCGizUyoK_uKH2GrSoj4GFVAN" :"https://drive.google.com/uc?export=download&id=1r3FzevfuTNgVyQF6btRYEyWwlFpDffTL"}><i className="fa fa-download"></i>
                     {this.props.isGerman ? 'Lebenslauf heruntergeladen' : 'Download CV'}</a>
                  </p>
               </div>
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;
